import { Box, Heading, Image } from '@wix/design-system';
import React from 'react';
import { clsx } from 'clsx';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import Users_Websites_A from '../../assets/images/SocialProof.png';
import s from './SocialProofCard.scss';
import { SocialProofMobileSvg } from './SocialProofMobileSvg';
import { useIsMobile } from '@wix/core-domain-search';
export const SocialProofCard = () => {
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement(Box, {
    height: isMobile ? '400px' : '340px',
    width: "100%",
    direction: "vertical",
    overflow: "hidden",
    align: "center",
    boxSizing: "border-box",
    transform: "translateZ(0)",
    backgroundColor: "#E2EFFF",
    borderRadius: "12px"
  }, /*#__PURE__*/React.createElement(Box, {
    height: "100%",
    width: "100%",
    align: "center",
    verticalAlign: "middle",
    position: "fixed"
  }, /*#__PURE__*/React.createElement(Box, {
    maxWidth: "720px",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "extraLarge",
    className: clsx(s.socialProofTitle, isMobile && s.mobile)
  }, t('domain_search_gate.domain_gate.social_proof')))), isMobile ? /*#__PURE__*/React.createElement(SocialProofMobileSvg, null) : /*#__PURE__*/React.createElement(Image, {
    src: Users_Websites_A,
    transparent: true,
    fit: "none",
    height: "340px"
  }));
};
//# sourceMappingURL=SocialProofCard.js.map